import React, { useState } from 'react'

type ContactBarProps = {
  prompt: string
  namePlaceholder: string
  phonePlaceholder: string
  saveLabel: string
  onSubmit: (payload: { name: string; contact: string }) => void
}

// Slim name + phone capture above the composer. Calls onSubmit (-> identify),
// then the parent hides it.
export const ContactBar: React.FC<ContactBarProps> = ({
  prompt,
  namePlaceholder,
  phonePlaceholder,
  saveLabel,
  onSubmit,
}) => {
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const canSave = name.trim().length > 0 && phone.trim().length > 0

  const submit = () => {
    if (!canSave) return
    onSubmit({ name: name.trim(), contact: phone.trim() })
  }

  return (
    <div className="wc-contact">
      <span className="wc-contact-prompt">{prompt}</span>
      <div className="wc-contact-row">
        <input
          className="wc-contact-input"
          type="text"
          value={name}
          placeholder={namePlaceholder}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), submit())}
        />
        <input
          className="wc-contact-input"
          type="tel"
          value={phone}
          placeholder={phonePlaceholder}
          onChange={(e) => setPhone(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), submit())}
        />
        <button
          type="button"
          className="wc-contact-save"
          disabled={!canSave}
          onClick={submit}
        >
          {saveLabel}
        </button>
      </div>
    </div>
  )
}
